export default "__VITE_ASSET__DerjWKB6__"